module.exports = __webpack_public_path__ + "img/gonglve2.a05caf6e.png";